import { render, staticRenderFns } from "./AccessAdvertiserForm.vue?vue&type=template&id=245b27ab&"
import script from "./AccessAdvertiserForm.vue?vue&type=script&lang=ts&"
export * from "./AccessAdvertiserForm.vue?vue&type=script&lang=ts&"
import style0 from "./AccessAdvertiserForm.vue?vue&type=style&index=0&id=245b27ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports